<template>
	<div class="flip-card-reverse-button" @click="$emit('reverse-event')">
		<span class="primary--text">{{ sideName }}</span>
		<v-icon color="primary" x-large>flip </v-icon>
	</div>
</template>
<script>
import { FlipCardSide, FlipCardSideName } from './flipCardSide.js';

export default {
	name: 'FlipcardToolbar',
	props: {
		visibleSide: { type: String, default: FlipCardSide.front }
	},
	computed: {
		sideName() {
			if (this.visibleSide === FlipCardSide.front) return FlipCardSideName.front;
			return FlipCardSideName.back;
		}
	}
};
</script>
<style>
.flip-card-reverse-button {
	position: absolute;
	top: 0;
	right: 0;
	transform: translateY(-130%);
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
}
.flip-card-reverse-button span {
	font-weight: bold;
}
</style>
